import React from 'react';
import { IconBuyPolicy, IconCompareQuotes, IconGetAdvice } from './icons';
import { ProcessBlockContent } from './types';
import { StepEmphasis } from './styles';

export const LIFE_PROCESS_CONTENT: ProcessBlockContent = {
  subtitle:
    'Policygenius provides free quotes tailored to your needs with support from licensed agents, helping you get insurance coverage fast so you can get on with life.',
  steps: [
    {
      header: 'Compare quotes',
      body: (
        <p>
          Answer a few health and lifestyle questions and{' '}
          <StepEmphasis>we&apos;ll calculate your quotes </StepEmphasis>
          from top insurers.
        </p>
      ),
      icon: IconCompareQuotes,
    },
    {
      header: 'Get advice',
      body: (
        <p>
          Our licensed agents make it easy to <StepEmphasis>understand your options </StepEmphasis>
          and find the right policy for your needs.
        </p>
      ),
      icon: IconGetAdvice,
    },
    {
      header: 'Buy a policy',
      body: (
        <p>
          Ready to apply? Our expert team will assist with the details to help you{' '}
          <StepEmphasis>get covered with confidence. </StepEmphasis>
        </p>
      ),
      icon: IconBuyPolicy,
    },
  ],
  ctaLabel: 'Get Your Free Quote',
};
